import { useEffect, useState } from 'react';

import { CidMedsus } from './CidMedsus';
import { CriterioMedsus } from './CriterioMedsus';
import { DocumentoMedsus } from './DocumentoMedsus';
import BoxConteudo from '../../../../../components/BoxConteudo';
import CustomCol from '../../../../../components/CustomCol';
import CustomInputText from '../../../../../components/CustomInputs/CustomInputText';
import CustomRow from '../../../../../components/CustomRow';
import WorkspaceFicha from '../../../../../components/WorkspaceFicha';
import { getUser } from '../../../../../modules/contexts/Auth/RequireAuth';
import { MedsusDiretrizVmpRegistro } from '../utils/medsusTypes';

interface Props {
  row: MedsusDiretrizVmpRegistro | null;
}

export function DiretrizVmpMedsusOffcanvas({ row }: Props) {
  const user = getUser();
  const userID = user.sub;

  const [logData, setLogData] = useState<MedsusDiretrizVmpRegistro | null>(
    null,
  );

  useEffect(() => {
    setLogData(row);
  }, [row]);

  //   const logs = functionLogData(logData);

  if (!row) {
    return null; // ⬅️ ESSENCIAL
  }

  return (
    <>
      <WorkspaceFicha>
        <BoxConteudo boxTitulo="Diretriz e Medicamento Associados">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol>
              <CustomInputText
                name="nome"
                title="Diretriz Clínica"
                value={row.diretrizNome}
                onChange={() => {
                  '';
                }}
                readOnly
              />
            </CustomCol>
          </CustomRow>
          <CustomRow>
            <CustomCol width="220px">
              <CustomInputText
                name="nome"
                title="Código OBM"
                value={row.vmpObm}
                onChange={() => {
                  '';
                }}
                readOnly
              />
            </CustomCol>

            <CustomCol>
              <CustomInputText
                name="nome"
                title="Nome do Medicamento"
                value={row.vmpNome}
                type="textArea"
                rows={1}
                onChange={() => {
                  '';
                }}
                readOnly
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <CidMedsus btDisable={false} vmpID={String(row.id)} userID={userID} />

        <CriterioMedsus
          btDisable={false}
          vmpID={String(row.id)}
          userID={userID}
        />

        <DocumentoMedsus
          btDisable={false}
          vmpID={String(row.id)}
          userID={userID}
        />
      </WorkspaceFicha>
    </>
  );
}
